import parse from '../../video/parseThumbnails';

module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id
      ? 'videos/' + this.id
      : 'videos');
  },
  parse: function (resource) {
    if (Array.isArray(resource)) {
      return resource.map(this.parse, this);
    }

    resource.data = parse(resource.data);
    return resource;
  }
});
